import TicketsDashboard from './TicketsDashboard';

export default TicketsDashboard;
